import FontAwesome from "react-native-vector-icons/Fonts/FontAwesome.ttf";
import Feather from "react-native-vector-icons/Fonts/Feather.ttf";

import AmaticSC from "assets/fonts/Amatic SC.ttf";
import Arial from "assets/fonts/Arial.ttf";
import Caveat from "assets/fonts/Caveat.ttf";
import Comfortaa from "assets/fonts/Comfortaa.ttf";
import ComicSansMS from "assets/fonts/Comic Sans MS.ttf";
import CourierNew from "assets/fonts/Courier New.ttf";
import EBGaramond from "assets/fonts/EB Garamond.ttf";
import Georgia from "assets/fonts/Georgia.ttf";
import Impact from "assets/fonts/Impact.ttf";
import Lobster from "assets/fonts/Lobster.ttf";
import Lora from "assets/fonts/Lora.ttf";
import Merriweather from "assets/fonts/Merriweather.ttf";
import Montserrat from "assets/fonts/Montserrat.ttf";
import Nunito from "assets/fonts/Nunito.ttf";
import Oswald from "assets/fonts/Oswald.ttf";
import Pacifico from "assets/fonts/Pacifico.ttf";
import PlayfairDisplay from "assets/fonts/Playfair Display.ttf";
import Poppins from "assets/fonts/Poppins.ttf";
import Pulse from "assets/fonts/Pulse.otf";
import RobotoMono from "assets/fonts/Roboto Mono.ttf";
import Roboto from "assets/fonts/Roboto.ttf";
import SegoeUI from "assets/fonts/Segoe UI.ttf";
import SFUIText from "assets/fonts/SF UI  Text.otf";
import Spectral from "assets/fonts/Spectral.ttf";
import TimesNewRoman from "assets/fonts/Times New Roman.ttf";
import TrebuchetMS from "assets/fonts/Trebuchet MS.ttf";
import Verdana from "assets/fonts/Verdana.ttf";
import Nastalique from "assets/fonts/fajer-noori-nastalique-regular.ttf";

const fonts = {
  FontAwesome,
  Feather,
  AmaticSC,
  Arial,
  Caveat,
  Comfortaa,
  ComicSansMS,
  CourierNew,
  EBGaramond,
  Georgia,
  Impact,
  Lobster,
  Lora,
  Montserrat,
  Merriweather,
  Nunito,
  Oswald,
  Pacifico,
  PlayfairDisplay,
  Poppins,
  Pulse,
  RobotoMono,
  Roboto,
  SegoeUI,
  SFUIText,
  Spectral,
  TimesNewRoman,
  TrebuchetMS,
  Verdana,
  Nastalique,
};

let fontStyles = "";

for (const [name, url] of Object.entries(fonts)) {
  const fontStyle = `
  @font-face {
    src: url(${url});
    font-family: ${name};
  }
  `;
  fontStyles += fontStyle;
}

export default fontStyles;
